import { useTranslation } from "react-i18next";
import { toastService } from "../../services/ToastService";
import { Copy, Check } from "lucide-react";
import { useState } from "react";

type Props = {
  text: string;
  label?: string;
};

function CopyText({text, label}: Props) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const copyFn = () => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    toastService.showToast(t("global.already_copy"));
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <button 
      className={`flex items-center justify-center gap-2 rounded-md hover:bg-gray-100 transition-colors ${label ? 'h-8 px-3' : 'h-8 w-8'}`}
      onClick={copyFn}
      title={t("global.copy")!}
    >
      {copied ? (
        <Check className="h-4 w-4 text-green-500" />
      ) : (
        <Copy className="h-4 w-4" />
      )}
      {label && !copied && (
        <span className="text-sm text-gray-700">{label}</span>
      )}
    </button>
  );
}

export default CopyText;
